export class GermanUfEquationFacade {
  systemName: string;
  insulationZone: string | null;
  profileType: string | null;
  glassThicknessMin: number | null;
  glassThicknessMax: number | null;
  jointWidth: number | null;
  profileWidth: number | null;
  k: number | null;
  l: number | null;

  constructor(row: Record<string, string | number | null>) {
    this.systemName = row['systemName'] as string;
    this.insulationZone = row['insulationZone'] as string | null;
    this.profileType = row['profileType'] as string | null;
    this.glassThicknessMin = row['glassThicknessMin'] as number | null;
    this.glassThicknessMax = row['glassThicknessMax'] as number | null;
    this.jointWidth = row['jointWidth'] as number | null;
    this.profileWidth = row['profileWidth'] as number | null;
    this.k = row['k'] as number | null;
    this.l = row['l'] as number | null;
  }
}